import { render, staticRenderFns } from "./ValidationCodeInput.vue?vue&type=template&id=489d2fe3&scoped=true&"
import script from "./ValidationCodeInput.vue?vue&type=script&lang=ts&"
export * from "./ValidationCodeInput.vue?vue&type=script&lang=ts&"
import style0 from "./ValidationCodeInput.vue?vue&type=style&index=0&id=489d2fe3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489d2fe3",
  null
  
)

export default component.exports